import { render, staticRenderFns } from "./StatePage.vue?vue&type=template&id=520c43ae&"
import script from "./StatePage.vue?vue&type=script&lang=js&"
export * from "./StatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports